import React, { useState, useEffect } from 'react'

const Header: React.FC = () => {
  const [isErLogoShown, setIsErLogoShown] = useState<boolean>(false)

  useEffect(() => {
    const domain = window.location.hostname
    setIsErLogoShown(
      domain === 'er-contributions.ru' ||
        domain === 'www.er-contributions.ru' ||
        domain === 'v2.er-contributions.ru'
    )
  }, [])

  return (
    <header className="flex flex-row items-center justify-between w-full max-w-screen-md px-5 py-4 mx-auto bg-primary">
      <a href="/home">
        <div className="flex-1">
          <img src="/img/appLogo.svg" alt="appLogo" style={{ height: '40px', width: 'auto' }} />
        </div>
      </a>

      {isErLogoShown && (
        <div>
          <img src="/img/erLogo.svg" alt="erLogo" style={{ height: '20px', width: 'auto' }} />
        </div>
      )}
    </header>
  )
}

export default Header
